/**
 * Shared helpers for classifying object categories by their (localized) name.
 * Mirrors the backend category-name checks so portal gating stays in sync.
 */
const normalize = (value: string | null | undefined): string =>
  (value ?? '').trim().toLocaleLowerCase('de-DE');

const HELICOPTER_CATEGORY_NAMES = ['helikopter', 'rettungshubschrauber'];
const OFFSHORE_CATEGORY_NAMES = ['windpark', 'plattform'];

export const normalizeCategoryName = normalize;

export const isHelicopterCategoryName = (name: string | null | undefined): boolean =>
  HELICOPTER_CATEGORY_NAMES.includes(normalize(name));

export const isOffshoreCategoryName = (name: string | null | undefined): boolean =>
  OFFSHORE_CATEGORY_NAMES.includes(normalize(name));
